import React from "react";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { useModal } from "../hooks/useModal";
import cn from "../lib/utils/class-name";

export default function DeleteNumber({
  deleteFunction,
  type,
}: {
  deleteFunction?: () => void;
  type?: string;
}) {
  const { closeModal } = useModal();

  return (
    <div className="w-[96%] md:w-[402px] mx-auto bg-background dark:bg-[#2A2C30] p-[32px] rounded-[8px] shadow-lg">
      <div className="flex flex-col gap-[41px] text-center">
        <div className="flex flex-col gap-[8px]">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-[#F04438]">
            Delete your {type === "knowledgebase" ? " file" : " number"}?
          </Text>
          <Text
            className={cn(
              "font-switzer text-[14px] text-[#758599] font-[400] w-[196px] mx-auto",
              type === "number" && "!w-[300px]"
            )}
          >
            {type === "knowledgebase"
              ? "Are you sure you want to delete your file"
              : "Once you delete your number, it cannot be recovered. You will need to set up a new number. Do you wish to continue?"}
            ?
          </Text>
        </div>
        <div className="flex gap-[18px] justify-center">
          <ActionIcon
            className="w-[109px] h-[35px] rounded-[4px] !bg-[#F2F2F2]"
            onClick={() => {
              closeModal();
            }}
          >
            <Text className="font-[400] text-[12px] text-[#191919] font-switzer">
              Cancel
            </Text>
          </ActionIcon>
          <ActionIcon
            className="w-[109px] h-[35px] rounded-[4px] !bg-[#F04438]"
            onClick={() => {
              deleteFunction && deleteFunction();
              closeModal();
            }}
          >
            <Text className="font-[400] text-[12px] text-[#FFFFFF] font-switzer">
              Delete
            </Text>
          </ActionIcon>
        </div>
      </div>
    </div>
  );
}
